// Convert many date formats (incl. Opera "10-SEP-26") to a YYYY-MM-DD value
// that an <input type="date"> accepts.
const MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
export function toDateInput(s) {
  if (!s) return "";
  s = String(s).trim();
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  m = s.match(/^(\d{1,2})[-/ ]([A-Za-z]{3,})[-/ ](\d{2,4})/); // 10-SEP-26 / 10 Sep 2026
  if (m) {
    const mon = MONTHS[m[2].slice(0, 3).toLowerCase()];
    if (mon !== undefined) {
      let yr = parseInt(m[3], 10); if (yr < 100) yr += 2000;
      return `${yr}-${String(mon + 1).padStart(2, "0")}-${m[1].padStart(2, "0")}`;
    }
  }
  m = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/); // 10/09/2026
  if (m) return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
  const d = new Date(s);
  if (!isNaN(d)) return d.toISOString().slice(0, 10);
  return "";
}

// "20-Sept-2026" style display for a YYYY-MM-DD date (used for guest DOB).
const DOB_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
export function formatDOB(s) {
  if (!s) return "";
  const m = String(s).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return s;
  const mon = DOB_MONTHS[parseInt(m[2], 10) - 1];
  if (!mon) return s;
  return `${m[3]}-${mon}-${m[1]}`;
}

// Timezone-aware date/time formatting. Times are stored in UTC and displayed
// in the timezone configured by admin (default Asia/Dhaka = GMT+6).
export function formatDT(iso, tz) {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: tz || "Asia/Dhaka",
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    }).format(new Date(iso));
  } catch {
    return new Date(iso).toLocaleString();
  }
}

export function formatTime(iso, tz) {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: tz || "Asia/Dhaka",
      hour: "2-digit", minute: "2-digit", hour12: true,
    }).format(new Date(iso));
  } catch {
    return "-";
  }
}

// "0d 01h 56m" style elapsed since a UTC timestamp
export function openFor(iso) {
  if (!iso) return "";
  const mins = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  return `${d}d ${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m`;
}
